import React from "react";
import { Link } from "react-router-dom";
import AdminRemoteDomainsTable from "./remote/sourcesAndPulls/AdminRemoteDomainsTable";
import AdminRemoteReviewsTable from "./remote/reviews/AdminRemoteReviewsTable";

export default function Admin() {
  return (
    <>
      <h1>Admin</h1>
      <h1>Remote Data</h1>
      <h2>
        <Link to={"/admin/remote"}>Sources and Pulls</Link>
      </h2>
      <AdminRemoteDomainsTable />
      <h2>
        <Link to={"/admin/remote/reviews"}>Reviews</Link>
      </h2>
      <AdminRemoteReviewsTable />
      <h2>
        <Link to={"/admin/remote/all/players"}>Players</Link>
      </h2>
      <h2>
        <Link to={"/admin/lists/rankings"}>Player Rankings</Link>
      </h2>
    </>
  );
}
